import React from 'react';

function DoubleQuotesIcon() {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 13.25C13.2426 13.25 14.25 12.2426 14.25 11V9.50007M14.25 9.50007V6.94885C14.25 6.52963 14.25 6.3197 14.1683 6.15942C14.0964 6.0183 13.9814 5.90365 13.8403 5.83175C13.6798 5.75 13.4701 5.75 13.0501 5.75H11.7001C11.28 5.75 11.0699 5.75 10.9094 5.83174C10.7683 5.90365 10.6537 6.0183 10.5817 6.15942C10.5 6.31986 10.5 6.53003 10.5 6.95007V8.30007C10.5 8.72011 10.5 8.92984 10.5817 9.09027C10.6536 9.23139 10.7683 9.34643 10.9094 9.41833C11.0697 9.5 11.2796 9.5 11.6988 9.5L14.25 9.50007ZM5.25 13.25C6.49264 13.25 7.5 12.2426 7.5 11L7.5 9.50007M7.5 9.50007V6.94884C7.5 6.52963 7.5 6.3197 7.41833 6.15942C7.34643 6.0183 7.23139 5.90365 7.09027 5.83175C6.92984 5.75 6.72011 5.75 6.30007 5.75H4.95007C4.53003 5.75 4.31986 5.75 4.15942 5.83174C4.0183 5.90365 3.90365 6.0183 3.83175 6.15942C3.75 6.31986 3.75 6.53003 3.75 6.95007V8.30007C3.75 8.72011 3.75 8.92984 3.83174 9.09027C3.90365 9.23139 4.0183 9.34643 4.15942 9.41833C4.3197 9.5 4.52962 9.5 4.94884 9.5L7.5 9.50007Z'
        stroke='black'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default DoubleQuotesIcon;
